import { render, staticRenderFns } from "./flowReferenceModal.vue?vue&type=template&id=567067c4&scoped=true"
import script from "./flowReferenceModal.vue?vue&type=script&lang=js"
export * from "./flowReferenceModal.vue?vue&type=script&lang=js"
import style0 from "./flowReferenceModal.vue?vue&type=style&index=0&id=567067c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567067c4",
  null
  
)

export default component.exports